































































































































import Vue from "vue";
import Component from "vue-class-component";
import { Prop } from "vue-property-decorator";
import { MedicalSpecification } from "@/components/medicalTransmissionEdit/types";
import { SelectItemString } from "@/types";
import NumberInput from "@/components/common/NumberInput.vue";

@Component({
  components: { NumberInput }
})
export default class BasicInfo2 extends Vue {
  @Prop() tab!: MedicalSpecification;
  @Prop() public_option_divs!: SelectItemString[]; //任意給付区分
}
